// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__IbQO4","title":"FrontImage_title__2ECH2"};